// 充值审核状态（目前只针对国网）
export enum RechargeCheckStatus {
    '待审核',
    '审核成功',
    '审核失败'
}
// 卡券状态
export enum CouponStatus {
    // '驳回' = -6,
    '未激活' = -5, // 生成卡默认，或驳回之后
    '待激活', // 生成卡时没选激活，后期主动提交申请
    '已作废' = -1,
    '已激活',
    '已绑定'
}
// 卡券激活状态
export enum CouponActiveStatus {
    '待激活',
    '已激活',
    '驳回'
}
// 卡券形态
export enum CouponShape {
    '实体卡' = 1,
    '电子码'
}
// 卡券形态
export enum CouponType {
    '蛋糕卡' = 2,
    '生活卡',
    '通用卡'
}
// 卡券属性
export enum CouponProp {
    '通用' = 1,
    '定制',
    '体验卡' = 4
}